import React, { useState } from 'react';
import { Body1, Headline } from '../components/FontStyles';
import Styled from 'styled-components';
import baseTheme from '../themes/baseTheme';
import ViewContainer from '../components/patterns/ViewContainer';
import Button from '../components/elements/Button';
import CalculatedValuesDisplay from '../components/elements/rxflow/CaluclatedValuesDisplay.js';

import { Flex } from 'rebass';
import useFormValues from '../resources/CustomHooks';
import {
  TextField,
  Slider,
  FormControl,
  Typography,
  Radio,
  Checkbox,
  RadioGroup,
  FormControlLabel
} from '@material-ui/core';
import Form from '../components/elements/forms/Form';
import * as Yup from 'yup';
import { Formik, Field, ErrorMessage } from 'formik';

const Panel = Styled(Flex)`
flex-wrap: wrap;
border: ${props => props.theme.border};
padding: ${props => props.theme.space[4]}px;
`;

const ButtonControlContainer = Styled(Flex)`

`;

const SettingsCalc = props => {
  const { inputs, handleInputChange, handleSubmit } = useFormValues();
  const [currentPanel, setCurrentPanel] = useState(1);
  const [calcComplete, setCalcComplete] = useState();
  const setValues = props.setValues;
  const prevValues = props.prevValues;

  console.log('Inputs : ');
  console.log(inputs);

  return (
    <ViewContainer width={1} justifyContent="center" flexWrap="wrap">
      <Flex width={0.8} flexWrap="wrap" justifyContent="center">
        <Flex width={1} mb={4} justifyContent="center">
          <Headline> Settings Calculator has been completed. </Headline>
          {calcComplete && <CalculatedValuesDisplay inputs={inputs} />}
        </Flex>
        {currentPanel === 1 && (
          <Panel className="panel1" panelNumber={1} width={1}>
            <Flex width={1}>
              <FormControl>
                <RadioGroup
                  defaultValue={inputs.training}
                  name="training"
                  row
                  onChange={e => handleInputChange(e, setValues, prevValues, 'training')}
                >
                  <Flex width={1}>
                    <Body1>Is your patient on reduced dose for switch to pump therapy?</Body1>
                  </Flex>
                  <FormControlLabel
                    name="reducedDose"
                    value="reducedDose"
                    control={<Radio color="default" />}
                    label={<Typography color="textSecondary">Yes</Typography>}
                  />
                  <FormControlLabel
                    name="notReducedDose"
                    value="notReducedDose"
                    control={<Radio color="default" />}
                    label={<Typography color="textSecondary">No</Typography>}
                  />
                </RadioGroup>
              </FormControl>
            </Flex>
            <Flex my={4} width={1} flexWrap="wrap" justifyContent="space-between">
              <Flex mb={3} justifyContent="center" width={1}>
                <Headline width={1}> Calculating Pump Total Daily Dose</Headline>
              </Flex>
              <Flex width={0.5} pr={2}>
                <TextField
                  fullWidth
                  variant="outlined"
                  name="dailyInsulinDose"
                  type="number"
                  label="Enter daily total insulin dose"
                  defaultValue={inputs.dailyInsulinDose}
                  onChange={e => handleInputChange(e, setValues, prevValues)}
                />
              </Flex>
              <Flex width={0.5} pl={2}>
                <TextField
                  fullWidth
                  variant="outlined"
                  name="patientWeight"
                  type="number"
                  label="Enter weight in lbs"
                  defaultValue={inputs.patientWeight}
                  onChange={e => handleInputChange(e, setValues, prevValues)}
                />
              </Flex>

              <ButtonControlContainer width={1} my={4} justifyContent="flex-end">
                {currentPanel > 1 && <Button onClick={() => setCurrentPanel(currentPanel - 1)}>Previous </Button>}
                <Button disabled onClick={() => setCurrentPanel(currentPanel + 1)}>
                  Next
                </Button>
              </ButtonControlContainer>
            </Flex>
          </Panel>
        )}
        {currentPanel === 2 && (
          <Panel panelNumber={2} className="panel2" width={1}>
            <Flex width={1}>
              <Body1> Calculate total daily basal dose </Body1>
            </Flex>
            <Flex width={1} flexWrap="wrap">
              <Flex width={1} mb={4}>
                <Body1> Select percentage of total daily dose to as basal: </Body1>
              </Flex>
              <Flex width={0.5}>
                <Slider
                  min={40}
                  max={50}
                  defaultValue={45}
                  valueLabelDisplay="on"
                  onChange={(e, value) => handleInputChange(e, setValues, prevValues, 'basalPercentageOfTDD', value)}
                />
              </Flex>
              <Flex width={0.5} pl={2}>
                <TextField
                  fullWidth
                  variant="outlined"
                  name="dailyCarbs"
                  type="number"
                  label="Enter daily carbs consumed"
                  defaultValue={inputs.dailyCarbs}
                  onChange={e => handleInputChange(e, setValues, prevValues)}
                />
              </Flex>
            </Flex>
            <ButtonControlContainer width={1} my={4} justifyContent="space-between">
              <Button disabled onClick={() => setCurrentPanel(currentPanel - 1)}>
                Previous
              </Button>
              <Button disabled onClick={() => setCurrentPanel(currentPanel + 1)}>
                Next
              </Button>
            </ButtonControlContainer>
          </Panel>
        )}
        {currentPanel === 3 && (
          <Panel className="panel3">
            <Flex width={1} flexWrap="wrap">
              <CalculatedValuesDisplay inputs={inputs} />
            </Flex>
          </Panel>
        )}
        {props.testingValues && (
          <Flex width={1} mt={5}>
            <CalculatedValuesDisplay inputs={inputs} />}
          </Flex>
        )}
      </Flex>
    </ViewContainer>
  );
};

export default SettingsCalc;
